import React, {Component} from 'react'
import {connect} from 'react-redux'
import {getNotificationsByWeek} from '../../services/reservoir'
import {createDismissedNotification, getDismissedNotifications, getStudyPeriodWeightings} from '../../services/vu'
import Notification from './Notification'
import {withRouter} from 'react-router-dom'
import parse from 'html-react-parser';

const mapStateToProps = ({courses: { selectedCourseCode, data }, course: { selectedCourse }, sliders, enrolledTeachingPeriods}) => {

  const courseSliders = sliders[selectedCourseCode]
  const {sliderItems = []} = courseSliders.data.find(slider => {
    return slider.id === courseSliders.defaultSlider
  })

  const selectedSliderItem = sliderItems.find(sliderItem => sliderItem.id === courseSliders.selectedSlide)
  const { teachingPeriods } = enrolledTeachingPeriods[selectedCourseCode]

  return {
    courseId: selectedCourseCode,
    admissionCategory: selectedCourse.admissionCategory,
    enrolledYear: selectedCourse.availabilityYear,
    college: selectedCourse.orgUnit,
    selectedSlide: sliders[selectedCourseCode].selectedSlide,
    activeCalendarType: selectedSliderItem.teachingPeriod ? selectedSliderItem.teachingPeriod.calendarType : false,
    associatedWeek: selectedSliderItem.associatedWeek.id,
    teachingPeriods: teachingPeriods
  }
}

class WeeklyNotifications extends Component {
  constructor (props) {
    super(props)

    this.state = {
      notifications: [],
      dismissedNotifications: [],
    }
  }

  componentDidMount () {
    this.loadDismissedNotifications()
    this.loadNotifications(this.props)

    getStudyPeriodWeightings().then(studyPeriodWeightings => {
      this.setState({
        studyPeriodWeightings: studyPeriodWeightings
      })
    })
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.courseId !== this.props.courseId ||
      prevProps.selectedSlide !== this.props.selectedSlide
    ) {
      this.loadNotifications(this.props)
    }
  }

  loadNotifications = props => {
    this.setState({
      notifications: []
    })


    getNotificationsByWeek(
      props.associatedWeek,
      props.admissionCategory,
      props.college,
      props.activeCalendarType,
    ).then((notifications) => {
      this.setState({
        notifications: notifications,
      })
    })
  }

  checkforResearchPeriodUnits = () => this.props.teachingPeriods.filter(item => ( item === 'RP2' || item === 'RP1' ));

  getTeachingPeriodName = (teachingPeriodCode) =>{
    let studyPeriodDescriptions = teachingPeriodCode.map( teachingPeriodCode =>
      this.state.studyPeriodWeightings.filter(studyPeriodWeighting => studyPeriodWeighting.studyPeriodCode === teachingPeriodCode)
    );
  
    let teachingPeriodNames = [];
    teachingPeriodNames = (studyPeriodDescriptions.map((data) =>
       data[0].studyPeriodDescription
    ));
    
    return teachingPeriodNames;
  }
  
  getResearchSupportText = () =>{
    return '<p>You are not enrolled in a time-based thesis unit.</br>Email <u>gradresearch@vu.edu.au</u> to organise your enrolment</p>';
  }

  loadDismissedNotifications = () => {
    getDismissedNotifications().then((dismissedNotifications = []) => {
      this.setState({
        dismissedNotifications: dismissedNotifications
      })
    })
  }

  handleDismissNotificationButtonClick = notificationId => {
    createDismissedNotification(notificationId).then(() => {
      this.loadDismissedNotifications()
    })
  }

  render() {
    return (
      <div className="row">
        {this.state.notifications
          .filter(notification => !this.state.dismissedNotifications.includes(notification.attributes.uuid))
          .map(notification => notification.attributes)
          .map(notification => (
            <div key={notification.drupal_internal__vid} className="col-xs-12">
              <Notification
                notificationId={notification.drupal_internal__vid}
                title={(this.props.admissionCategory === "RESEARCH" && this.checkforResearchPeriodUnits().length !== 0) ? (notification.field_notification_heading+" enrolled in "+this.getTeachingPeriodName(this.checkforResearchPeriodUnits())) : notification.field_notification_heading}
                content={(this.props.admissionCategory === "RESEARCH" && this.checkforResearchPeriodUnits().length === 0)? parse(this.getResearchSupportText()) : notification.field_description1}
                onDismiss={notificationId => this.handleDismissNotificationButtonClick(notificationId)}
              />
            </div>
          ))
        }
      </div>
    )
  }
}

export default withRouter(connect(mapStateToProps)(WeeklyNotifications))
